@import '~tippy.js/dist/tippy.css';
@import '~tippy.js/dist/border.css';

.tippy-box[data-theme~='white'] {
  background: var(--gray-white);
  color: var(--gray-700);
  padding: 12px 16px;
  border: 1px solid var(--gray-400);
  border-radius: 16px;
  font-size: 16px;
  line-height: 1.5;
  a {
    color: var(--blue-dark);
  }
}

.tippy-box[data-theme~='white'][data-placement^='top'] > .tippy-arrow::before {
  border-top-color: var(--gray-white);
}
.tippy-box[data-theme~='white'][data-placement^='bottom'] > .tippy-arrow::before {
  border-bottom-color: var(--gray-white);
}
.tippy-box[data-theme~='white'][data-placement^='left'] > .tippy-arrow::before {
  border-left-color: var(--gray-white);
}
.tippy-box[data-theme~='white'][data-placement^='right'] > .tippy-arrow::before {
  border-right-color: var(--gray-white);
}
